import { useUserTier } from '@trustpad/launchpad';
import * as React from 'react';
import { Badge } from 'react-bootstrap';

import { usePool } from '~features/pools';
import { SaleStatusBadge } from '~features/pools/components/SaleStatusBadge';
import { SaleWhitelistBadge } from '~features/pools/components/SaleWhitelistBadge';
import { PoolToken } from '~features/pools/types';

import { BlackLevelBadge } from './BlackLevelBadge';

export function TokenInfo() {
  const { pool } = usePool();
  const { token, sale, fundToken } = pool;
  const { tierState } = useUserTier();

  return (
    <div className="flex items-center">
      <div className="mr-3">
        <TokenImage {...token} />
      </div>

      <div className="space-y-2">
        <div>
          <h2 className="text-2xl font-secondary tracking-wide">
            {token.name}
          </h2>
          <div className="text-sm font-secondary text-ignored">
            {token.symbol
              ? `${token.symbol} / ${fundToken.symbol}`
              : fundToken.symbol}
          </div>
        </div>

        <div className="flex items-center space-x-2 flex-wrap">
          <SaleStatusBadge
            status={sale.status}
            refunded={tierState.tier.multiplier > 0 && sale.refunded}
          />

          {false ? (
            <BlackLevelBadge withLock />
          ) : (
            <SaleWhitelistBadge
              hasWhitelist={sale.hasWhitelist}
              access={pool.access}
              isPublic={sale.isPublic}
              isLevels={sale.isTiered}
              allLevels={sale.levelsOpenAll}
            />
          )}

          {pool.kyc && (
            <Badge
              pill
              variant="warning"
              className="py-1 px-2 bg-opacity-40 bg-yellow-400 text-yellow-500 font-normal">
              KYC
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
}

function TokenImage({
  imageSrc,
  symbol,
}: Pick<PoolToken, 'imageSrc' | 'symbol'>) {
  return (
    <div className="inline-block rounded-full p-1 brand-bg">
      <div className="h-16 w-16 bg-darkGray rounded-full flex items-center justify-center">
        <img src={imageSrc} alt={symbol} className="h-full rounded-full" />
      </div>
    </div>
  );
}
